import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Userpilot } from "userpilot";
import { setUser } from "@sentry/react";

const IdentifyUser = () => {
  const { user, authStatus } = useAuthenticator();
  const posthog = usePostHog();

  useEffect(() => {
    const asyncMethod = async () => {
      if (authStatus === "authenticated" && user) {
        setUser({
          id: user.userId,
          email: user.signInDetails?.loginId?.toLowerCase(),
          ip_address: "{{auto}}",
        });
      } else if (authStatus !== "authenticated") {
        setUser(null);
      }
    };

    asyncMethod();
  }, [authStatus, user]);

  useEffect(() => {
    if (posthog && user) {
      const userProperties = {
        user_type: "PROVIDER",
        email: user.signInDetails?.loginId,
      };
      posthog.identify(user.userId, userProperties);

      Userpilot.identify(user.userId, {
        email: user.signInDetails?.loginId,
      });
    }
  }, [posthog, user]);

  return null;
};

export default IdentifyUser;
